import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-bye_tag",
  "use": "icon-bye_tag-usage",
  "viewBox": "0 0 29 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 29 18\" id=\"icon-bye_tag\">\n<path d=\"M27,1c0.6,0,1,0.4,1,1v14c0,0.6-0.4,1-1,1H2c-0.6,0-1-0.4-1-1V2c0-0.6,0.4-1,1-1H27 M27,0H2C0.9,0,0,0.9,0,2v14\n\tc0,1.1,0.9,2,2,2h25c1.1,0,2-0.9,2-2V2C29,0.9,28.1,0,27,0L27,0z\" />\n<g>\n\t<path d=\"M6.4,4.3c2,0,3.5,0.3,3.5,2.4c0,0.9-0.4,1.7-1.3,2v0c1.2,0.2,1.9,1.1,1.9,2.3c0,2.5-1.8,2.8-3.8,2.8H3.9V4.3H6.4z M5.6,8.1\n\t\th1.1c1,0,1.5-0.3,1.5-1.2c0-0.7-0.3-1.1-1.5-1.1H5.6V8.1z M5.6,12.2h1.1c1.2,0,2-0.1,2-1.3c0-1-0.8-1.3-1.8-1.3H5.6V12.2z\" />\n\t<path d=\"M12.7,4.3c0.6,1.8,1.1,3.3,1.8,4.6h0.1c0.7-1.4,1.2-2.9,1.8-4.6H18c-0.7,2.2-1.7,4.4-2.7,6.3v3.1h-1.7v-3.1\n\t\tc-1-1.9-2-4.2-2.7-6.3H12.7z\" />\n\t<path d=\"M25.1,4.3L25,5.8H21v2.3h3.4v1.5H21v2.5H25v1.5h-5.6V4.3H25.1z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/bye_tag.svg
// module id = 266
// module chunks = 0 1